// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ccc9b638","502":"a1e45c40","545":"cb465c23","683":"be06ccaa","990":"d8a86265"}[chunkId] + ".chunk.js";
};